import { Box, ButtonBase, SxProps, Theme, useTheme } from "@mui/material";

// ----------------------------------------------------------------------

interface ChoiceChipsProps<T extends string> {
  options: Array<{ value: T; label: string }>;
  value: T;
  onChange: (value: T) => void;
  sx?: SxProps<Theme>;
}

/** Linha de chips de seleção única (pills); quebra em mais linhas quando não cabe */
export default function ChoiceChips<T extends string>({ options, value, onChange, sx }: ChoiceChipsProps<T>) {
  const theme = useTheme();

  return (
    <Box
      sx={[
        // Quebra em vez de rolar: no celular o último chip ficava fora da dobra
        // sem nenhuma pista, parecendo cortado, e a rolagem lateral da fila
        // encadeava o gesto para o navegador.
        { display: "flex", flexWrap: "wrap", gap: 1, rowGap: 1, pb: 0.5 },
        ...(Array.isArray(sx) ? sx : [sx]),
      ] as SxProps<Theme>}
    >
      {options.map(({ value: optionValue, label }) => {
        const active = optionValue === value;
        return (
          <ButtonBase
            key={optionValue}
            aria-pressed={active}
            onClick={() => { if (optionValue !== value) onChange(optionValue) }}
            sx={{
              height: 40,
              px: 2,
              flexShrink: 0,
              borderRadius: "100px",
              border: `1.5px solid ${active ? theme.palette.primary.main : theme.palette.divider}`,
              backgroundColor: active ? "primary.main" : "background.paper",
              color: active ? "primary.contrastText" : theme.palette.brand.heroText,
              fontFamily: theme.typography.fontFamily,
              fontSize: "13px",
              fontWeight: 600,
              transition: "all .15s",
            }}
          >
            {label}
          </ButtonBase>
        );
      })}
    </Box>
  );
}
